import { RJSFSchema, UiSchema } from "@rjsf/utils";
import { customizeValidator } from "@rjsf/validator-ajv8";
import JSONSchemaForm from "@rjsf/bootstrap-4";
import { useTranslation } from "react-i18next";
import { MouseEventHandler, useContext, useEffect, useState } from "react";
import customFormats from "@beeldit/core/custom-validations/custom-validation";
import useProcessSchema from "@beeldit/core/hooks/useProcessSchema";
import widgets from "@beeldit/core/widgets/widgets";
import AddressSelector from "@bloonde/location/addresses/components/AddressSelector";
import BeelditSwitchInput from "@beeldit/core/components/BeelditSwitchInput";
import FeatureMultiSelector from "@beeldit/resource-management/features/components/FeatureMultiSelector";
import UserSelector from "@beeldit/user-and-access/users/components/UserSelector";

interface Prop {
  formConfig: {
    formRef: any;
    onSubmit: any;
    context: any;
  };
}

interface Context {
  element: any;
  setElement: (element: any) => MouseEventHandler;
  backendFormErrors: any;
}

function CandidateForm(props: Prop) {
  const { formRef, onSubmit, context } = props.formConfig;
  const { element, setElement, backendFormErrors } =
    useContext<Context>(context);

  const { t } = useTranslation();

  const [finalSchema, setFinalSchema] = useState<RJSFSchema>({});

  const translations = {
    name: t("name"),
    features: t("features"),
    candidate_type_id: t("candidate_type_id"),
    holidays: t("holidays"),
    previous_time: t("previous_time"),
    assignment_amount: t("assignment_amount"),
    participation_percentage: t("participation_percentage"),
    user_id: t("user_id"),
  };

  let schema: RJSFSchema = {
    type: "object",
    // required: ['minutes', 'customer_id', 'task', 'date', 'report_id'],
    properties: {
      name: {
        type: "string",
        title: translations.name,
      },
      user_id: {
        type: ["number", "null"],
        title: translations.user_id,
      },
      participation_percentage: {
        type: "number",
        title: translations.participation_percentage,
        default: 100,
        minimum: 0,
        maximum: 100,
      },
      feature_ids: {
        type: "array",
        title: translations.features,
        items: {
          type: "number",
        },
      },
      holidays: {
        type: "array",
        title: translations.holidays,
        items: {
          type: "string",
          format: "date",
        },
      },
    },
  };
  const uiSchema: UiSchema = {
    "ui:submitButtonOptions": {
      props: {
        disabled: false,
        className: "btn btn-info",
      },
      norender: true,
    },
    candidate_type_id: {
      "ui:widget": "candidate-type-selector",
      "ui:placeholder": t("select_a_type"),
    },
    feature_ids: {
      "ui:widget": "feature-selector",
      // "ui:placeholder": t("select_features"),
    },
    user_id: {
      "ui:widget": "user-selector",
      "ui:placeholder": t("select_user"),
    },
  };
  const customWidgets = {
    ...widgets,
    ...{
      "feature-selector": FeatureMultiSelector,
      "user-selector": UserSelector,
    },
  };
  const handleChange = (type: any) => {
    /** Este método de momento es necesario aunque en realidad no tenga sentido, pero se debe a un bug de la libreria */
    // Actualizar el estado solo si no hay errores de validación
    setElement(type.formData);
    return console.log.bind(console, type);
  };
  const log = (type: any) => {
    return console.log.bind(console, type);
  };

  const formats = customFormats;
  const validator = customizeValidator({ customFormats: formats });

  const processSchemaFunction = useProcessSchema();

  useEffect(() => {
    setFinalSchema(processSchemaFunction(schema, element));
  }, [element]);

  return (
    <JSONSchemaForm
      noHtml5Validate
      showErrorList={false}
      ref={formRef}
      schema={schema}
      uiSchema={uiSchema}
      widgets={customWidgets}
      formData={element}
      validator={validator}
      onChange={handleChange}
      onSubmit={onSubmit}
      onError={log("errors")}
      extraErrors={backendFormErrors}
    />
  );
}

export default CandidateForm;
